import React from "react";

export default function useArchivedFilter({ selected, setSelected }) {
  return {
    key: "archived",
    label: "Status",
    filter: (
      <div style={{ padding: "8px" }}>
        <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <input type="checkbox" checked={selected} onChange={e => setSelected(e.target.checked)} />
          Exclude archived
        </label>
      </div>
    ),
    appliedFilter: selected
      ? {
          key: "archived",
          label: "Excluding archived",
          onRemove: () => setSelected(false)
        }
      : null,
    clearAll: () => setSelected(false),
    onRemove: () => setSelected(false)
  };
}
